export enum Position {
  Top = 'top',
  Left = 'left',
  Right = 'right',
  Bottom = 'bottom',
  RightStart = 'right-start',
  LeftStart = 'left-start',
  BottomStart = 'bottom-start'
}
